module.exports = __webpack_public_path__ + "img/icons_20.4b606a32.png";